import Utils from "../../common/Utils";
import Button from "reactstrap/es/Button";
import React from "react";
import _ from 'lodash';

const ErrorView = ({ children , error , retryCallback , retryMessage = "Retry" }) => {

    return error ? <div className="p-5 text-center">
        <i className="fa fa-exclamation-triangle fa-3x"/>
        <p>{_.isString(error) ? error : Utils.getResponseError(error)}</p>
        {retryCallback && <Button color={"warning"} onClick={retryCallback}><i className="fa fa-refresh"/> {retryMessage}</Button>}
    </div> : <React.Fragment>{children}</React.Fragment>;
};

export default ErrorView;


// WEBPACK FOOTER //
// ./src/components/Elements/ErrorView.js